import { LogOut, Plus } from "lucide-react";

export default function Header({ onAdd, onLogout, stats, onHome }) {
  // Navegación SPA: ir a home siempre
  const handleLogoClick = () => {
    if (onHome) onHome();
  };
  return (
    <header className="bg-cinema-header/80 backdrop-blur-sm border-b border-cinema-border sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo + Título clickable */}
          <button
            onClick={handleLogoClick}
            className="flex items-center gap-3 group focus:outline-none"
            style={{ background: "none", border: "none", padding: 0 }}
          >
            <div className="flex items-center justify-center w-9 h-9 bg-cinema-accent/10 rounded-xl overflow-hidden">
              <img
                src="/assets/logo.png"
                alt="My Cinema Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div>
              <h1 className="text-lg font-bold text-white leading-none group-hover:text-cinema-accent transition-colors cursor-pointer">
                My Cinema
              </h1>
              <p className="text-xs text-steel-400 hidden sm:block">
                {stats.pending + stats.watched} títulos
              </p>
            </div>
          </button>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <button
              onClick={onAdd}
              className="flex items-center gap-2 bg-steel-600 hover:bg-steel-400 text-white font-medium px-4 py-2.5 rounded-xl transition-all duration-200 shadow-lg shadow-steel-700/20 text-sm"
            >
              <Plus size={18} />
              <span className="hidden sm:inline">Añadir</span>
            </button>
            <button
              onClick={onLogout}
              className="p-2.5 text-steel-400 hover:text-steel-200 hover:bg-cinema-card rounded-xl transition-all"
              title="Cerrar sesión"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
